var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',[_c('v-row',{staticClass:"pl-3 pb-3",attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('b',[_vm._v(_vm._s(_vm.label))])]),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }